import type { MouseEventHandler } from 'react';

import { keyframes } from '@emotion/react';
import { Box, Typography } from '@mui/material';

import logo from '@/assets/images/gxLogo.svg';

const logoTextReveal = keyframes({
  from: { opacity: 0, transform: 'translateX(-6px)' },
  to: { opacity: 1, transform: 'translateX(0)' }
});

const goTextBaseSx = {
  userSelect: 'none',
  fontWeight: 500,
  lineHeight: 1,
  ml: 0.5,
  animation: `${logoTextReveal} 0.35s ease-out`
} as const;

const containerBaseSx = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center'
} as const;

type GoLogoProps = {
  size?: number;
  open?: boolean;
  onClick?: MouseEventHandler<HTMLElement>;
};

const GoLogo = ({ size = 64, open = true, onClick }: GoLogoProps) => {
  const activeCursor = open ? 'w-resize' : 'e-resize';
  const cursor = onClick ? activeCursor : 'initial';

  return (
    <Box
      sx={[containerBaseSx, { cursor }]}
      onClick={onClick}
    >
      <Box
        alt='GX'
        component='img'
        src={logo}
        sx={{ height: `${size}px` }}
      />
      {open && (
        <Typography
          color='primary'
          style={{ fontSize: size }}
          sx={goTextBaseSx}
        >
          Go
        </Typography>
      )}
    </Box>
  );
};

export default GoLogo;
